import { useEffect, useState } from 'react';

// Vertical green scan band animates top→bottom→top over 1.6s, matching the
// SCREENS.md spec for the AI-citește screen.
export function ScanningOverlay() {
  const [y, setY] = useState(0);
  useEffect(() => {
    let start = performance.now();
    let raf = 0;
    const tick = (t: number) => {
      const elapsed = (t - start) / 1600;
      const pos = Math.abs((elapsed % 2) - 1); // triangle wave 0→1→0
      setY(pos);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      <div
        className="absolute left-0 right-0 h-1.5 bg-accent shadow-[0_0_20px_rgba(0,255,140,0.4)]"
        style={{ top: `${y * 100}%`, transform: 'translateY(-50%)' }}
      />
      <div
        className="absolute left-0 right-0 bg-accent/10"
        style={{ top: 0, height: `${y * 100}%` }}
      />
    </div>
  );
}
